/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import {
    object, arrayOf, shape, string,
} from 'prop-types';
import Grid from '@material-ui/core/Grid';
import ROSSMobileOrderListItem from './ROSSMobileOrderListItem';
import { deepObjectExtend } from '../../utils/object';
import { combineStyle } from '../../style/combineStyle';
import { main as MainStyle } from '../../style/main';
import { MobileOrderListStyle } from '../../style/MobileOrderListStyle';

const styles = ({ typography, palette }) => deepObjectExtend(
    combineStyle(typography, palette, {
        MainStyle,
        MobileOrderListStyle,
    }),
);

const ROSSMobileOrderList = ({ classes, order, brand }) => (
    <div className={classes.MobileOrderListStyle}>
        <Grid container>
            <Grid item xs={12}>
                {
                        order?.map((data, i) => (
                            <ROSSMobileOrderListItem key={['_', i].join('')} index={i} order={data} brand={brand} />
                        ))
                }
            </Grid>
        </Grid>
    </div>
);

ROSSMobileOrderList.propTypes = {
    classes: object.isRequired,
    order: arrayOf(
        shape({
            items: arrayOf(
                shape({
                    productSku: string,
                    deliveryDate: string,
                    prdImgCtg: string,
                    price: string,
                    productName: string,
                }),
            ),
            recipientProfiles: arrayOf(
                shape({
                    addressDetail: arrayOf(
                        shape({
                            addressLine1: string,
                            addressLine2: string,
                            addressLine3: string,
                            cityName: string,
                            countryCode: string,
                            state: string,
                            zipCode: string,
                        }),
                    ),
                }),
            ),
        }),
    ).isRequired,
    brand: object.isRequired,
};

export default withStyles(styles)(ROSSMobileOrderList);
